import { render, staticRenderFns } from "./VfxPopup.vue?vue&type=template&id=44ae4df4"
import script from "./VfxPopup.vue?vue&type=script&lang=js"
export * from "./VfxPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports